"use client";

import { useI18n } from "@/i18n";

const SITE = "GuineeMall";
const CONTACT_EMAIL = "18918855336@126.com";

const styles = {
  page: {
    minHeight: "100vh",
    background: "#F5F7F5",
    paddingTop: 96,
    paddingBottom: 80,
  },
  container: {
    maxWidth: 820,
    margin: "0 auto",
    padding: "0 24px",
  },
  card: {
    background: "#ffffff",
    borderRadius: 16,
    border: "1px solid #ECEEEC",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
    padding: "48px 56px",
  },
  title: {
    fontSize: 32,
    fontWeight: 800,
    color: "#111827",
    margin: 0,
    letterSpacing: "-0.01em",
  },
  subtitle: {
    fontSize: 14,
    color: "#6B7280",
    marginTop: 10,
    marginBottom: 32,
    paddingBottom: 24,
    borderBottom: "1px solid #F1F3F1",
  },
  section: { marginTop: 32 },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#111827",
    margin: "0 0 12px",
  },
  body: { fontSize: 15, lineHeight: 1.8, color: "#374151" },
  list: { margin: "8px 0 0", paddingLeft: 22 },
  listItem: { marginBottom: 6 },
  contactBox: {
    marginTop: 32,
    padding: "20px 24px",
    background: "#F4F6F4",
    borderRadius: 12,
    fontSize: 14,
    color: "#374151",
    lineHeight: 1.8,
  },
};

function Section({ title, children }) {
  return (
    <section style={styles.section}>
      <h2 style={styles.sectionTitle}>{title}</h2>
      <div style={styles.body}>{children}</div>
    </section>
  );
}

export default function PrivacyPage() {
  const { t } = useI18n();
  const pt = (k) => t(`privacy.${k}`);
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <article style={styles.card}>
          <h1 style={styles.title}>{t("footer.legal.privacy")}</h1>
          <div style={styles.subtitle}>
            {t("privacyUi.updated")}：2026 · {t("footer.company")}
          </div>

          <Section title={pt("s1Title")}>
            <p>{pt("s1p1")}</p>
            <p>{pt("s1p2")}</p>
          </Section>

          <Section title={pt("s2Title")}>
            <p>{pt("s2Intro")}</p>
            <ul style={styles.list}>
              {pt("s2list").map((item, i) => (
                <li key={i} style={styles.listItem}>{item}</li>
              ))}
            </ul>
          </Section>

          <Section title={pt("s3Title")}>
            <p>{pt("s3p1")}</p>
          </Section>

          <Section title={pt("s4Title")}>
            <ul style={styles.list}>
              {pt("s4list").map((item, i) => (
                <li key={i} style={styles.listItem}>{item}</li>
              ))}
            </ul>
          </Section>

          <Section title={pt("s5Title")}>
            <p>{pt("s5p1")}</p>
          </Section>

          <Section title={pt("s6Title")}>
            <p>{pt("s6Intro")}</p>
            <ul style={styles.list}>
              {pt("s6list").map((item, i) => (
                <li key={i} style={styles.listItem}>{item}</li>
              ))}
            </ul>
            <p>{pt("s6p1")}</p>
          </Section>

          <Section title={pt("s7Title")}>
            <p>{pt("s7p1")}</p>
          </Section>

          <Section title={pt("s8Title")}>
            <p>{pt("s8p1")}</p>
          </Section>

          <div style={styles.contactBox}>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>{pt("contactBoxTitle")}</div>
            <div>{pt("contactBoxMsg")}</div>
            <div style={{ marginTop: 8 }}>
              {pt("contactEmail")} <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: "#2F9E44" }}>{CONTACT_EMAIL}</a>
            </div>
            <div>{pt("contactOperator")} {t("footer.company")}</div>
          </div>
        </article>
      </div>
    </div>
  );
}
